'use client';

import { CSSProperties, ReactNode } from 'react';

import { Loader } from '@calm-web/design-system';

// Inline styles to prevent flash of unstyled content during hydration
const wrapperStyles: CSSProperties = {
	width: '200px',
	height: '100px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	position: 'absolute',
	left: '50%',
	top: '50%',
	transform: 'translate(-50%, -50%)',
};

const loaderContainerStyles: CSSProperties = {
	height: '100%',
	width: '160px',
	display: 'block',
	margin: '0 auto',
};

/**
 * Client component wrapper for full-page loader with inline styles.
 * Uses inline styles instead of styled-components to prevent flash of
 * unstyled content during hydration.
 */
const FullPageLoader = (): ReactNode => {
	return (
		<div style={wrapperStyles}>
			<style>{`.full-page-loader-wrapper svg circle { fill: #e2e2e2; }`}</style>
			<div style={loaderContainerStyles} className="full-page-loader-wrapper">
				<Loader color="gray1" />
			</div>
		</div>
	);
};

export default FullPageLoader;
